import React, { useRef, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { styled, alpha } from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import InputBase from '@mui/material/InputBase'
import Avatar from '@mui/material/Avatar'
import Button from '@mui/material/Button'
import RefreshIcon from '@mui/icons-material/Refresh'
import InfoIcon from '@mui/icons-material/Info'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import LogoutIcon from '@mui/icons-material/Logout'
import logo from '../../assests/logo.png'
import { capitalizeFirst } from '../common'
import { Portal } from '@mui/material'
import {
  downloadTextFile,
  findObjctByValueFromArrayOfObject,
  focusElemnt,
  isEmpty,
  lineInputNavigation3,
  MultiligualDropData,
  openInNewWindow,
  redirectToLogin,
} from '../common/helper'
import {
  cancelBooking,
  cancelBookingByAdmin,
  cencelDelivery,
  getDestBranchCreditLimit,
  luggegePrint,
  ticketFormatAll,
  updateAlertError,
  userRollRightEditRights,
} from '../../store/common/common_action'
import { updateSelectedActivity, updatePaymentType, updateSearchBy } from '../../store/common/common_action'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import * as mdt from '../../../src/components/common/modaltypes'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee'
import { BookingPrintPreview, StickerPrintPreview, SuccessPopUp, SuccessPopUp1 } from '../common/snippets'
import { Checkbox, FormControlLabel, Tooltip } from '@mui/material'
import { updateModal, setSearchLrData } from '../../store/common/common_action'
import {
  booking,
  reports,
  admin,
  recharge,
  operationsPrivilege,
  deliveryMemo,
  generalSettings,
  acountingReports,
  BrchUsrMaster,
  allReports,
  deliveryV2Cargo,
  dashBoard,
  mtplMaster,
  updateOutDelivery,
  pendingOutDelivery,
  outDeliveryStatus,
  selectUser,
  DashBoardV2,
} from '../common/constants'

import Alert from '../common/alert'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { rePrintCargoBooking } from '../../store/booking/booking_action'
import PricingInquiry from './pricingInquiry'
import BranchInquiry from './branchInquiry'
import APIKeyUpdateModal from '../common/APIKeyUpdateModal'
import BookingCancelByAdminUICopy from '../content/BookingActivity/BookingCancelByAdminUI copy'
import { getOwnChildUsers } from '../../store/reports/reports_action'
import RechargeReqModal from './RechargeReqModal'
import UpdatePassword from '../common/updatePasswordModal'
import { useAtom } from 'jotai'
import { alertAtom, enabelBookingHistoryAtom, modalAtom } from '../common/jotaiState/globalStateAtoms'
import { SearchLrPopupUI } from './searchLRpopup'
import { selectLrAtom, stickerFromAtom, stickerRangeAtom, stickerToAtom } from '../common/jotaiState/lrSearchAtoms'
import { LrTrackingPopupUI } from './lrTrackingPopupUI'
import { LrTrackingHorizontalPopupUI } from './lrTrackingHorizontalPopupUI'
import { isHorizontalLrTracing } from './lrTrackingPopupConstants'
import { DEMO_COMPANY, GAJRAJ, HANS_COMPANY_ID, RAJESH_TRANSPORT, STA_COMPANY_ID, ZOJOCOM_COOL, PLANET_COACH, ARK_COACH, DALA_SERVICES, TAQWA_BUS_AND_PARCEL } from '../../helper/companyIdhardcode'
import { StickerConfirmation } from './stickerConfirmation'
import { ShortcutOutlined } from '@mui/icons-material'
import { ShortcutsPopup } from './shortcutsPopup'
import { CargoRoleRightsAtom, companySettingsAtom, startBranchCreditPolling } from '../common/jotaiState/commonStateAtoms'
import { BookingIDAtom } from '../common/jotaiState/bookingStateAtoms'
import { EXPENSE_TAB_JOB_IDS } from '../content/OperationsPrivilege/constant'
import useToken from '../helpers/useTokens'
import { useTranslation } from '../../i18n/I18nProvider'
import LanguageIcon from '@mui/icons-material/Language';
import MtplOdpValidationModal, { isMtplMasterOdpValidated } from './MtplOdpValidationModal'
import UserCollectionPopup from './UserCollectionPopup'
const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha('#e5f3fe', 0.95),
  '&:hover': {
    backgroundColor: alpha('#e5f3fe', 0.85),
  },
  marginLeft: 0,
  color: '#000',
  width: '100%',
  minWidth: '12rem',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}))
const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}))

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch',
      },
    },
  },
}))

function Header({
  data,
  getDestBranchCreditLimit,
  updateModal,
  setSearchLrData,
  getOwnChildUsers,
  updateAlertError,
  cancelBookingByAdmin,
  ...rest
}) {
  const { setLanguage, language, translations } = useTranslation();
  const cs = translations?.common || {}
  const bum = translations?.branchAndUserMaster || {}
  const de = translations?.delivery || {}
  const od = translations?.outDelivery || {}
  const iq = translations?.inquiry || {}
  const pf = translations?.profile || {}
  const rh = translations?.recharge || {}
  const mtpl = translations?.mtplMaster || {}
  const { updateSelectedActivity, cancelBooking, cencelDelivery, rePrintCargoBooking, luggegePrint, userRollRightEditRights } = rest
  const { ticketFormatAll } = rest
  const isInitialMount = useRef(true)
  const [searchParams, setSearchParams] = useSearchParams()
  const [roleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1 = [] } = roleRights
  const [{ AllowBranchselection = 0 } = {}] = Table1

  const { common, reports: reportsState, booking: bookingL } = data
  let { branchCreditLimit, destBranchCreditLimit, destBrnch, loginData } = { ...common }
  const { intBranchID, intUserID, intCompanyID } = loginData
  let { modalType, showModal, lrStatus = false, alert } = common
  const { bookingCancelResponse, cancelDelivery, printType, branchConfiguration } = common
  const { ticketReprintFormat, rePrintDelivery, printDelivery } = common
  const [alertJ, setAlert] = useAtom(alertAtom)
  const [modal, setModal] = useAtom(modalAtom)
  if (alertJ?.show && !alert.show) {
    alert = JSON.parse(JSON.stringify(alert))
    alert.show = alertJ?.show
    alert.msg = alertJ?.msg
    alert.nextId = alertJ.nextId
    alert.success = alertJ?.success || false
    if (alertJ.close) {
      alert.close = alertJ.close
    }
  }
  const { ownChildUsers } = reportsState
  const { cargoReprintData } = bookingL
  const [companySettings] = useAtom(companySettingsAtom)
  const { StickerCopiesType } = companySettings
  const { EnableRechargeRequest, SetDefaultYesOnPrint } = companySettings
  const { DefaultCurrencyID = 0 } = companySettings
  const { IsLoggedInUserForOfflineBooking = 0 } = companySettings
  const [currentView, setCurrentView] = useState(searchParams.get('view') || common.selectedActvty)
  const [profileVisible, setProfileVisible] = useState(false)
  const [inquiryVisible, setInquiryVisible] = useState(false)
  const [menuVisible, setMenuVisible] = useState(false)
  const [menuVisible2, setMenuVisible2] = useState(false)
  const [dropPortalStyle, setDropPortalStyle] = useState({})
  const [inquiryDropPortalStyle, setInquiryDropPortalStyle] = useState({})
  const shortcutsPopupRef = useRef(null)
  const profilePopupRef = useRef(null)
  const menuPopupRef = useRef(null)
  const profileButtonRef = useRef(null)
  const languageVisibleRef = useRef(null)
  const inquiryButtonRef = useRef(null)
  const [selectLr] = useAtom(selectLrAtom)
  const [mainMenu, setMainMenu] = useState(true)
  const [localPopup, setPopup] = useState(false)
  const [reprintLrData, setReprintLrData] = useState(null)
  const [qrList, setQrList] = useState([])
  const [stickerFrom, setStickerFrom] = useAtom(stickerFromAtom)
  const [stickerTo, setStickerTo] = useAtom(stickerToAtom)
  const [stickerRange, setStickerRange] = useAtom(stickerRangeAtom)
  const [creditBalance, setCreditBalance] = useState([])
  const [isStickerPrintReady, setIsStickerPrintReady] = useState(false)
  const [acountingMenu, setAcountingMenu] = useState(false)
  const [adminMenu, setAdminMenu] = useState(false)
  const [mtplMasterMenu, setMtplMasterMenu] = useState(false)
  const [odpPopupOpen, setOdpPopupOpen] = useState(false)
  const [outDeliveryMenu, setOutDeliveryMenu] = useState(false)
  const [reportsActive, setReportActive] = useState([])
  const [showOutDeliveryMenu, setShowOutDeliveryMenu] = useState(false)
  const [showExpenseMenu, setShowExpenseMenu] = useState(false)
  const [bookingIDAtom, setBookingIDAtom] = useAtom(BookingIDAtom)
  const [enableBookingHistory, setEnableBookingHistory] = useAtom(enabelBookingHistoryAtom)
  const isTemplateStickerCompany = [ZOJOCOM_COOL, PLANET_COACH, ARK_COACH, DALA_SERVICES, TAQWA_BUS_AND_PARCEL].includes(intCompanyID)
  const [languageVisible, setLanguageVisible] = useState(false)
  const [confirmPop, setConfirmPop] = useState({
    isOpen: false,
    data: {},
  })
  const CustomTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(() => ({
    [`& .MuiTooltip-tooltip`]: {
      fontSize: '12px',
      boxShadow: '0px 3px 6px rgba(0,0,0,0.1)',
    },
  }))
  const consignmentDetails = lrStatus?.Data?.Table
  const lrInfo = consignmentDetails?.[0]
  const LrTrackData = lrStatus?.Data?.Table1
  const firstStatus = LrTrackData ? LrTrackData?.[0] : false
  const listContainerRef = useRef(null)
  const initializedRef = useRef(false)
  const [height, setHeight] = useState(window.innerHeight - 100)
  const updateHeight = () => {
    if (listContainerRef.current) {
      const top = listContainerRef.current.getBoundingClientRect().top
      const availableHeight = window.innerHeight - top - 10
      setHeight(availableHeight)
    }
  }
  useEffect(() => {
    let intervalId

    if ((menuVisible || acountingMenu) && !initializedRef.current && listContainerRef.current) {
      initializedRef.current = true
      updateHeight()
      window.addEventListener('resize', updateHeight)
    } else if ((menuVisible || acountingMenu) && !initializedRef.current) {
      intervalId = setInterval(() => {
        if (listContainerRef.current) {
          initializedRef.current = true
          updateHeight()
          window.addEventListener('resize', updateHeight)
          clearInterval(intervalId)
        }
      }, 10)
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
      if (initializedRef.current) {
        window.removeEventListener('resize', updateHeight)
      }
    }
  }, [menuVisible, acountingMenu])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      //if (loginData?.IsAdmin || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin) {
      const userData = {
        intCompanyID: loginData?.intCompanyID,
        intIsActive: 1,
      }
      getOwnChildUsers(userData)
      const payload = { intCompanyID: loginData.intCompanyID, intBranchID: loginData.intBranchID }
      if ([RAJESH_TRANSPORT].includes(loginData.intCompanyID)) {
        startBranchCreditPolling(payload)
      }
    }
    // }
  }, [loginData])
  useEffect(() => {
    let intervalId
    const checkToken = () => {
      const saved = sessionStorage.getItem('token1')
      if (!saved) return
      clearInterval(intervalId)
      let allGSPagesActive = []
      try {
        allGSPagesActive = JSON.parse(saved) || []
      } catch {
        allGSPagesActive = []
      }
      setReportActive(allGSPagesActive)
      const hasOutDelivery = allGSPagesActive.some((a) => [512, 513, 572].includes(a.JobID) && a.IsActive)
      setShowOutDeliveryMenu(hasOutDelivery)
      const hasActiveExpense = EXPENSE_TAB_JOB_IDS.some((jobId) => allGSPagesActive.some((a) => a.JobID === jobId && a.IsActive))
      setShowExpenseMenu(hasActiveExpense)
    }
    intervalId = setInterval(checkToken, 500)
    return () => clearInterval(intervalId)
  }, [])

  useEffect(() => {
    if (profilePopupRef && profilePopupRef.current) {
      profilePopupRef.current.addEventListener('wheel', noScroll, { passive: false })
      return profilePopupRef.current.removeEventListener('wheel', noScroll, { passive: false })
    }
  }, [profilePopupRef, profileVisible])
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false
      return
    }
    const viewParam = searchParams.get('view')
    const newView = !viewParam ? common.selectedActvty : viewParam
    setCurrentView((prev) => {
      if (prev !== newView) return newView
      return prev
    })
  }, [searchParams, common.selectedActvty])
  const handleAlert = (msg = false, nextId = '') => {
    if (!(msg instanceof Event)) {
      if (msg) {
        setAlert({ show: true, msg })
      } else {
        setAlert({ show: false, msg: '' })
        setTimeout(() => {
          focusElemnt(nextId)
        }, 0)
      }
    }
    updateAlertError({ show: false, msg: '' })
  }
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const obj = {
        RoleID: loginData?.intRoleID,
        IsLuggage: 0,
      }
      userRollRightEditRights(obj)
    }
  }, [loginData])
  useEffect(() => {
    if (!isEmpty(destBrnch)) {
      const data = {
        intCompanyID: destBrnch?.CompanyID,
        intBranchID: destBrnch?.BranchID,
      }
      getDestBranchCreditLimit(data)
    }
  }, [destBrnch])
  useEffect(() => {
    // setting style of portal based on parents position in the dom
    const dims = profileButtonRef.current.getBoundingClientRect()
    const style = {
      position: 'absolute',
      top: 10,
      right: 25,
      width: 350,
    }
    setDropPortalStyle(style)
  }, [profileButtonRef])
  useEffect(() => {
    // setting style of portal based on parents position in the dom
    const dims = inquiryButtonRef.current.getBoundingClientRect()
    const styleInquiry = {
      position: 'absolute',
      top: 10,
      right: 100,
      width: 150,
    }
    setInquiryDropPortalStyle(styleInquiry)
  }, [inquiryButtonRef])
  useEffect(() => {
    if (bookingCancelResponse === true) updateModal(true, 'camcelBookingSuccess')
  }, [bookingCancelResponse])
  useEffect(() => {
    if (cancelDelivery.status === 'Success') {
      updateModal(true, 'camcelDeliverySuccess')
    } else {
      handleAlert(cancelDelivery?.ErrMessage)
    }
  }, [cancelDelivery.status])
  useEffect(() => {
    if (!isEmpty(cargoReprintData) && cargoReprintData != null) {
      const { CargoHasBilltyLaserPrint, BilltyTemplate, TicketFormatID, BookingDetID, BookingID, NoA, FormatTypeCust } = cargoReprintData
      const consignmentUnits = NoA.split(',')
      const consignmentID = BookingDetID.split(',')
      let qrList = []
      consignmentUnits.map((el, index) => {
        for (let i = 1; i <= el; i++) {
          qrList.push(`${BookingID}~${consignmentID[index]}~${i}`)
        }
      })
      if (StickerCopiesType === 2) {
        setQrList(qrList.map((el, index) => ({ index: index + 1, data: el })))
        setStickerFrom(1)
        setStickerTo(qrList.length)
        setStickerRange(qrList.length)
      } else {
        setQrList([{ index: 1, data: qrList[0] }])
        setStickerFrom(1)
        setStickerTo(1)
        setStickerRange(1)
      }
      if (CargoHasBilltyLaserPrint == 1 && BilltyTemplate != '') {
        openInNewWindow(BilltyTemplate)
        showStickerPopup()
      } else {
        ticketFormatAll({ TicketFormatID, printType: 'ticketReprint', FormatType: FormatTypeCust }, true)
      }
    }
  }, [cargoReprintData])

  useEffect(() => {
    const [reprintData = {}] = printDelivery.length ? printDelivery : rePrintDelivery
    if (!isEmpty(reprintData) && reprintData != null) {
      const { CargoHasBilltyLaserPrint, BilltyTemplate, TicketFormatID, FormatTypeCust } = reprintData
      if (CargoHasBilltyLaserPrint == 1 && BilltyTemplate) {
        openInNewWindow(BilltyTemplate)
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      } else {
        ticketFormatAll({ TicketFormatID: TicketFormatID, printType: 'ticketReprintDelivery', FormatType: FormatTypeCust }, true)
      }
    }
  }, [rePrintDelivery, printDelivery])
  useEffect(() => {
    if ((!isEmpty(cargoReprintData) || !isEmpty(rePrintDelivery)) && (cargoReprintData !== null || rePrintDelivery !== null)) {
      const { BilltyTemplate } = { ...cargoReprintData }
      if (!isEmpty(ticketReprintFormat) && !BilltyTemplate && printType === 'ticketReprint') {
        setModal('bookingTicketReprint')
      }
      if (!isEmpty(ticketReprintFormat) && printType === 'ticketReprintDelivery') {
        setModal('bookingTicketReprint')
      }
      if (!isEmpty(ticketReprintFormat) && isStickerPrintReady && printType === 'stickerReprint') {
        setModal('reprintSticker')
      }
    }
  }, [ticketReprintFormat, printType, isStickerPrintReady])
  const toggleProfileVisible = () => {
    setProfileVisible(!profileVisible)
  }
  const toggleInquiryVisible = () => {
    setInquiryVisible(!inquiryVisible)
    setTimeout(() => {
      focusElemnt(`branchInquiry`)
    }, 2)
  }
  const toggleMenuVisible = (e) => {
    e && e.stopPropagation()
    setMenuVisible((a) => !a)
    setMenuVisible2((a) => !a)
  }
  useEffect(() => {
    // Function to handle clicks outside of menu section
    function handleClickOutside(event) {
      if (odpPopupOpen) return
      if (menuPopupRef.current && !menuPopupRef.current.contains(event.target) && menuVisible2) {
        setMenuVisible(false)
        setMenuVisible2(false)
      }
    }

    // // Add event listener when the portal is open
    if (menuVisible) {
      document.addEventListener('click', handleClickOutside)
    } else {
      setTimeout(() => {
        setMenuVisible(false)
        setMenuVisible2(false)
      }, 0)
    }

    // // Clean up function to remove event listener
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [menuVisible, menuPopupRef, odpPopupOpen])
  useEffect(() => {
    let branchCreditLimitBalance = ''
    let branchCreditLimitBalanceUsage = ''
    if (branchCreditLimit.IsCargoCreditLimit == 1) {
      if (branchCreditLimit.CargoCreditLimit == -1) {
        branchCreditLimitBalance = `Credit: Unlimited | Usage : ` + branchCreditLimit.CargoBalance
        branchCreditLimitBalanceUsage = `Usage : ` + branchCreditLimit.CargoBalance
      } else {
        let creditPercentage = (parseInt(branchCreditLimit.CargoBalance) * 100) / parseInt(branchCreditLimit.CargoCreditLimit)
        branchCreditLimitBalance = {
          value:
            `Source Branch: Credit: ` +
            branchCreditLimit.CargoCreditLimit +
            ` | Usage : ` +
            branchCreditLimit.CargoBalance +
            `, ` +
            creditPercentage,
        }
        branchCreditLimitBalanceUsage = {
          value: `Source Branch: ` + `Usage : ` + branchCreditLimit.CargoBalance,
        }
        let balanceData = { value: '' }
        if (loginData?.intCompanyID == 406) {
          balanceData = [branchCreditLimitBalanceUsage]
        } else {
          balanceData = [branchCreditLimitBalance]
        }
        // branchCreditLimitBalanceTwo ={value:`Destination Branch: Credit: ` + branchCreditLimit.CargoCreditLimit + ` | Usage : ` + branchCreditLimit.CargoBalance + `, ` + creditPercentage}
        // const balanceData = [branchCreditLimitBalance]
        setCreditBalance(balanceData)
      }
    }
  }, [branchCreditLimit])
  useEffect(() => {
    let branchCreditLimitBalanceTwo = ''
    let branchCreditLimitBalanceTwoUsage = ''
    if (creditBalance?.length > 0) {
      if (!isEmpty(destBranchCreditLimit)) {
        if (destBranchCreditLimit.IsCargoCreditLimit == 1) {
          if (destBranchCreditLimit.CargoCreditLimit == -1) {
            branchCreditLimitBalanceTwo = `Credit: Unlimited | Usage : ` + destBranchCreditLimit.CargoBalance
            branchCreditLimitBalanceTwoUsage = `Usage : ` + destBranchCreditLimit.CargoBalance
          } else {
            let creditPercentage = (parseInt(destBranchCreditLimit.CargoBalance) * 100) / parseInt(destBranchCreditLimit.CargoCreditLimit)
            branchCreditLimitBalanceTwo = {
              value:
                `Destination Branch: Credit: ` +
                destBranchCreditLimit.CargoCreditLimit +
                ` | Usage : ` +
                destBranchCreditLimit.CargoBalance +
                `, ` +
                creditPercentage.toFixed(0) +
                `%`,
            }
            branchCreditLimitBalanceTwoUsage = {
              value: `Destination Branch: ` + ` Usage : ` + destBranchCreditLimit.CargoBalance,
            }
            // const balanceData = [creditBalance?.[0], branchCreditLimitBalanceTwo]
            let balanceData = { value: '' }
            if (loginData?.intCompanyID == 406) {
              balanceData = [creditBalance?.[0], branchCreditLimitBalanceTwoUsage]
            } else {
              balanceData = [creditBalance?.[0], branchCreditLimitBalanceTwo]
            }
            setCreditBalance(balanceData)
          }
        } else {
          branchCreditLimitBalanceTwo = { value: `Destination Branch: Credit: ` + 0 + ` | Usage : NA` + `, ` + 'NA' }
          branchCreditLimitBalanceTwoUsage = { value: `Destination Branch: ` + ` Usage : NA` }

          // const balanceData = [creditBalance?.[0], branchCreditLimitBalanceTwo]
          let balanceData = { value: '' }
          if (loginData?.intCompanyID == 406) {
            balanceData = [creditBalance?.[0], branchCreditLimitBalanceTwoUsage]
          } else {
            balanceData = [creditBalance?.[0], branchCreditLimitBalanceTwo]
          }
          setCreditBalance(balanceData)
        }
      }
    }
  }, [branchCreditLimit, destBranchCreditLimit])
  const bookingCancel = () => {
    const dblRefundAmt = [1, 6, 8, 9].includes(Number(lrInfo.PaymentType)) ? lrInfo.NetAmount : 0
    const cancelData = {
      intBookingID: lrInfo?.BookingID,
      strLRNo: lrInfo?.LRNO,
      strReasonforRefund: 'not-available',
      intUserID: loginData.intUserID,
      dblRefundAmt,
    }
    cancelBooking(cancelData)
    updateModal()
  }
  const deliveryCancel = () => {
    const CancelData = { BookingID: lrInfo?.BookingID, Lrnumber: lrInfo?.LRNO, Remarks: 'not-available' }
    cencelDelivery(loginData, CancelData)
  }
  const bookingReprint = (lrData = lrInfo) => {
    if (sessionStorage.getItem('DeviceID')) {
      const data = {
        BookingID: lrData?.BookingID,
        UserID: intUserID,
        BranchID: intBranchID,
        CompanyID: intCompanyID,
      }
      setBookingIDAtom(lrData?.BookingID)
      downloadTextFile(data, 'BookingID_')
      showStickerPopup()
    } else {
      rePrintCargoBooking({
        intBookingID: lrData?.BookingID,
        intBranchID: intBranchID,
        intUserID: intUserID,
        strLRNO: '',
        intmode:0,
        mode: isTemplateStickerCompany ? 2 : 0,
      })
    }
  }
  const deliveryReprint = (lrData = lrInfo) => {
    if (sessionStorage.getItem('DeviceID')) {
      const data = {
        BookingID: lrData?.BookingID,
        UserID: intUserID,
        BranchID: intBranchID,
        CompanyID: intCompanyID,
        LRNO: lrData?.LRNO,
      }
      downloadTextFile(data, 'DeliveryID_')
      setTimeout(() => {
        handleStickerClose()
      }, 100)
    } else {
      const data = {
        intBookingID: lrData?.BookingID,
        intBranchID: intBranchID,
        intUserID: intUserID,
        strLRNO: lrData?.LRNO,
      }
      luggegePrint(data, true)
    }
  }
  const clickbookingCancel = () => {
    const isAdminUser = loginData?.IsAdmin || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin
    const isLockCancelCompany = [GAJRAJ, STA_COMPANY_ID].includes(loginData?.intCompanyID)
    if (isAdminUser || isLockCancelCompany) {
      updateModal(true, 'BookingCancelByAdmin')
    } else {
      setPopup('bookingCancelUI')
    }
  }
  const clickdeliveryCancel = () => {
    setPopup('deliveryCancelUI')
  }
  const clickbookingReprint = (lrData = selectLr || lrInfo) => {
    setReprintLrData(lrData || lrInfo)
    setPopup('bookingReprintUI')
  }
  const clickDeliveryReprint = (lrData = selectLr || lrInfo) => {
    setReprintLrData(lrData || lrInfo)
    setPopup('deliveryReprintUI')
  }
  const controlData = {
    bookingCancel: clickbookingCancel,
    deliveryCancel: clickdeliveryCancel,
    bookingReprint: clickbookingReprint,
    deliveryReprint: clickDeliveryReprint,
  }
  const ShowBookingCancel = () => {
    const data = {
      successMessage: de.areYouSureWantToCancelDelivery || 'Are you sure want to cancel ?',
      buttonId1: '',
      buttonId2: '',
      yesAction: () => {
        bookingCancel()
        setPopup(false)
      },
      noAction: () => setPopup(false),
    }
    return <SuccessPopUp data={data} updateModal={setPopup} />
  }
  const ShowDeliveryCancel = () => {
    const data = {
      successMessage: de.areYouSureWantToCancelDelivery || 'Are you sure want to cancel ?',
      buttonId1: '',
      buttonId2: '',
      yesAction: () => {
        deliveryCancel()
        setPopup(false)
      },
      noAction: () => setPopup(false),
    }

    return <SuccessPopUp data={data} updateModal={setPopup} />
  }
  const ShowBookingReprint = () => {
    const data = {
      successMessage: de.areYouSureWantToReprint || 'Are you sure want to reprint ?',
      buttonId1: '',
      buttonId2: '',
      yesAction: () => {
        bookingReprint(reprintLrData || lrInfo)
        setPopup(false)
      },
      noAction: () => setPopup(false),
    }

    return <SuccessPopUp data={data} updateModal={setPopup} />
  }
  const ShowDeliveryReprint = () => {
    const data = {
      successMessage: de.areYouSureWantToReprint || 'Are you sure want to reprint ?',
      buttonId1: '',
      buttonId2: '',
      yesAction: () => {
        deliveryReprint(reprintLrData || lrInfo)
        setPopup(false)
      },
      noAction: () => setPopup(false),
    }
    return <SuccessPopUp data={data} updateModal={setPopup} />
  }
  const CancelBookingSuccessModal = () => {
    const data = {
      successMessage: de.bookingCancelledSuccessfully || 'Booking cancelled successfully',
      buttonId1: 'deliveryyes',
      yesAction: () => {
        updateModal(false)
      },
    }
    return <SuccessPopUp1 data={data} updateModal={updateModal} />
  }
  const CancelDeliverySuccessModal = () => {
    const data = {
      successMessage: de.deliveryCancelledSuccessfully || 'Delivery cancelled successfully',
      buttonId1: 'deliveryyes',
      yesAction: () => {
        window.location.reload(false)
      },
    }
    return <SuccessPopUp1 data={data} updateModal={()=>window.location.reload(false)} />
  }
  const showStickerPopup = () => {
    const CargoHasSticker = branchConfiguration?.CargoHasSticker || 0
    if (CargoHasSticker === 1 && searchParams.get('view') !== 'Offline Booking') {
      setModal('reprintStickerConfirmation')
    } else {
      setTimeout(() => {
        window.location.reload(false)
      }, 0)
    }
  }
  const ShowTicketPreview = () => {
    const [reprintData = {}] = printDelivery.length ? printDelivery : rePrintDelivery
    let { TicketDimension, TicketFormat, QRandLogoFormat } = ticketReprintFormat
    TicketDimension = TicketDimension?.split(',')
    TicketFormat = TicketFormat?.split('^')
    QRandLogoFormat = QRandLogoFormat.split('^')
    return (
      <BookingPrintPreview
        TicketDimension={TicketDimension}
        TicketFormat={TicketFormat}
        TicketData={printType === 'ticketReprintDelivery' ? reprintData : cargoReprintData}
        QRandLogoFormat={QRandLogoFormat}
        intUserID={intUserID}
        onClose={printType === 'ticketReprintDelivery' ? () => window.location.reload(false) : showStickerPopup}
      />
    )
  }
  useEffect(() => {
    if (sessionStorage.getItem('DeviceID') && lrStatus?.status && StickerCopiesType === 2) {
      const Table = lrStatus?.Data?.Table || []
      if (Table.length) {
        const totalUnits = Table.reduce((acc, item) => acc + Number(item.Quantity), 0)
        setStickerTo(totalUnits || 1)
        setStickerRange(totalUnits || 1)
      }
    }
  }, [lrStatus])
  const handleStickerPrint = () => {
    if (sessionStorage.getItem('DeviceID')) {
      const data = {
        BookingID: bookingIDAtom,
        UserID: intUserID,
        BranchID: intBranchID,
        CompanyID: intCompanyID,
        From: stickerFrom,
        To: stickerTo,
      }
      downloadTextFile(data, 'StickerPrint_')
      setTimeout(() => {
        handleStickerClose()
      }, 100)
    } else {
      if (isTemplateStickerCompany && cargoReprintData?.StickerTemplate) {
        openInNewWindow(cargoReprintData.StickerTemplate)
        handleStickerClose()
        return
      }
      setIsStickerPrintReady(true)
      printStickerData()
    }
  }
  const printStickerData = () => {
    if (!isEmpty(cargoReprintData) && cargoReprintData != null) {
      const { TickerFormatIDSticker } = { ...cargoReprintData }
      ticketFormatAll({ TicketFormatID: TickerFormatIDSticker, printType: 'stickerReprint' }, true)
    }
  }
  const handleStickerClose = () => {
    window.location.reload(false)
    updateModal()
  }
  const ShowStickerPreview = () => {
    let { TicketDimension, TicketFormat, QRandLogoFormat, FormatFont } = ticketReprintFormat
    TicketDimension = TicketDimension?.split(',')
    TicketFormat = TicketFormat?.split('^')
    QRandLogoFormat = QRandLogoFormat.split('^')
    return (
      <StickerPrintPreview
        TicketDimension={TicketDimension}
        TicketFormat={TicketFormat}
        TicketData={cargoReprintData}
        QRandLogoFormat={QRandLogoFormat}
        onClose={handleStickerClose}
        qrList={qrList}
        range={[stickerFrom, stickerTo]}
        FormatFont={FormatFont}
      />
    )
  }

  const noScroll = (e) => {
    e.preventDefault()
  }
  const logout = (e) => {
    sessionStorage.clear()
    redirectToLogin()
  }

  const openMtplMasterSubmenu = () => {
    setMainMenu(false)
    setMtplMasterMenu(true)
  }

  const handleMtplMasterClick = (e) => {
    e.stopPropagation()
    if (isMtplMasterOdpValidated()) {
      openMtplMasterSubmenu()
      return
    }
    setOdpPopupOpen(true)
  }

  const handleOdpValidated = () => {
    setOdpPopupOpen(false)
    openMtplMasterSubmenu()
  }

  const handleOdpClose = () => {
    setOdpPopupOpen(false)
  }

  const handleLrSearch = () => {
    updateModal(true, mdt.searchPopup)
  }

  const handleMenu = (menuType, id, e) => {
    toggleMenuVisible(e)
    const params = {}
    for (let entry of searchParams.entries()) {
      params[entry[0]] = entry[1]
    }
    switch (menuType) {
      case booking: {
        updateSelectedActivity(booking)
        setSearchParams({ view: booking })
        break
      }
      case deliveryV2Cargo: {
        updateSelectedActivity(deliveryV2Cargo)
        setSearchParams({ view: deliveryV2Cargo })
        break
      }
      case reports: {
        updateSelectedActivity(reports)
        params.view = reports
        params.id = id
        setSearchParams(params)
        break
      }
      case admin: {
        updateSelectedActivity(admin)
        setSearchParams({ view: admin })
        break
      }
      case selectUser: {
        updateSelectedActivity(selectUser)
        setSearchParams({ view: selectUser })
        break
      }
      case recharge: {
        updateSelectedActivity(recharge)
        setSearchParams({ view: recharge })
        break
      }
      case operationsPrivilege: {
        updateSelectedActivity(operationsPrivilege)
        setSearchParams({ view: operationsPrivilege })
        break
      }
      case deliveryMemo: {
        updateSelectedActivity(deliveryMemo)
        setSearchParams({ view: deliveryMemo })
        break
      }
      case 'planDispatch':{
        updateSelectedActivity('planDispatch')
        setSearchParams({ view: 'planDispatch' })
        break
      }
      case acountingReports: {
        updateSelectedActivity(acountingReports)
        params.view = acountingReports
        params.id = id
        setSearchParams(params)
        break
      }
      case mtplMaster: {
        updateSelectedActivity(mtplMaster)
        params.view = mtplMaster
        params.id = id
        setSearchParams(params)
        break
      }
      case generalSettings: {
        updateSelectedActivity(generalSettings)
        setSearchParams({ view: generalSettings })
        break
      }
      case BrchUsrMaster: {
        updateSelectedActivity(BrchUsrMaster)
        setSearchParams({ view: BrchUsrMaster })
        break
      }
      case dashBoard: {
        updateSelectedActivity(dashBoard)
        setSearchParams({ view: dashBoard })
        break
      }
      case DashBoardV2: {
        updateSelectedActivity(DashBoardV2)
        setSearchParams({ view: DashBoardV2 })
        break
      }
      case updateOutDelivery: {
        updateSelectedActivity(updateOutDelivery)
        setSearchParams({ view: updateOutDelivery })
        break
      }
      case pendingOutDelivery: {
        updateSelectedActivity(pendingOutDelivery)
        setSearchParams({ view: pendingOutDelivery })
        break
      }
      case outDeliveryStatus: {
        updateSelectedActivity(outDeliveryStatus)
        setSearchParams({ view: outDeliveryStatus })
        break
      }
      default:
        break
    }
  }
  const toggleLanguageVisible = () => {
    setLanguageVisible((prev) => !prev)
  }
  const showRechargeRequestModal = () => {
    let data = {
      headText: rh.cargoRechargeRequest || 'Cargo | Recharge Request',
      loginData: loginData,
    }
    return <RechargeReqModal data={data} updateModal={setModal} companySettings={companySettings} />
  }

  const handleCancelBooking = (data) => {
    const { selUser, validPaymentTypes = [], cancelRemark, lrInfo } = data.data
    if (selUser == '' || selUser == ' ') {
      updateAlertError({ show: true, msg: 'Select Cancel By User', nextId: 'cancelByUserBtn' })
    } else if (cancelRemark === '') {
      updateAlertError({ show: true, msg: 'Select Remark', nextId: 'remark' })
    } else {
      const dblRefundAmt = validPaymentTypes.includes(lrInfo.PaymentType) ? lrInfo.NetAmount : 0
      const cancelData = {
        intProcessedUserID: loginData?.intUserID,
        intUserID: selUser?.UserID,
        intBookingID: lrInfo?.BookingID,
        strLRNo: lrInfo?.LRNo,
        strReasonforRefund: cancelRemark,
        dblRefundAmt,
      }
      cancelBookingByAdmin(cancelData)
      setConfirmPop({
        isOpen: false,
        data: {},
      })
      updateModal(false, 'BookingCancelByAdmin')
    }
  }
  const handleConfirmPop = (data = {}) => {
    setConfirmPop({
      isOpen: true,
      data: data,
    })
  }

  const ShowDispatchSuccess = () => {
    const data = {
      successMessage: (de.cancellationPenaltyMessage || 'For this LR Cancellation Penalty of Rs. {{penalty}} /- will be applied').replace('{{penalty}}', lrInfo.LRPenalty || 0),
      otherMessage: de.areYouSureWantToContinue || 'Are you sure want to continue?',
      buttonId1: 'CancellationYes',
      headTxt: de.cancellationConfirmTitle || 'Cancellation Confirm',
      buttonId2: 'CancellationNo',
      yesAction: () => {
        handleCancelBooking(confirmPop.data)
      },
      noAction: () => {
        setConfirmPop({
          isOpen: false,
          data: {},
        })
      },
    }
    return (
      <SuccessPopUp
        data={data}
        updateModal={() => {
          setConfirmPop({
            isOpen: false,
            data: {},
          })
        }}
      />
    )
  }
  return (
    <>
      <Box sx={{ flexGrow: 1 }} className='global-header'>
        <AppBar position="static" className="header-nav">
          <Toolbar sx={{ minHeight: '5.2rem !important' }} style={{ justifyContent: 'space-between' }} className="header-toolbar">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div>
                <input id="menu-toggle" type="checkbox" checked={menuVisible} onChange={toggleMenuVisible} />
                <label htmlFor="menu-toggle" className="menu-button-container">
                  <div className="menu-button"></div>
                </label>
              </div>
              <Avatar alt="Cargo web" variant="square" src={logo} />
              &nbsp;&nbsp;
              <Typography variant="h3" noWrap component="div" sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' }, fontSize: 20 }}>
                Cargo | {capitalizeFirst(currentView)}
              </Typography>
              {DefaultCurrencyID !== 2 && (
                <UserCollectionPopup companyId={intCompanyID} branchId={intBranchID} userId={intUserID} />
              )}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
              <CustomTooltip title="Languages">
                <div ref={languageVisibleRef} onClick={toggleLanguageVisible}>
                  <LanguageIcon fontSize="large" />
                </div>
              </CustomTooltip>
              <Button
                ref={shortcutsPopupRef}
                size="large"
                color="white"
                startIcon={<ShortcutOutlined />}
                onClick={() => setModal('shortcutsPopup')}
              >
                Shortcuts
              </Button>
              <Search>
                <SearchIconWrapper>
                  {/* <SearchIcon /> */}
                  <img src="/images/SearchLR.png" alt="" style={{ height: '17px', width: '17px' }} />
                </SearchIconWrapper>
                <StyledInputBase
                  placeholder="Search LR"
                  inputProps={{ 'aria-label': 'search' }}
                  style={{ width: '130px' }}
                  onClick={handleLrSearch}
                />
              </Search>
              <Button
                className="refresh-button"
                size="large"
                color="white"
                startIcon={<InfoIcon />}
                ref={inquiryButtonRef}
                endIcon={
                  inquiryVisible ? (
                    <FontAwesomeIcon icon={faCaretUp} className="updown" />
                  ) : (
                    <FontAwesomeIcon icon={faCaretDown} className="updown" />
                  )
                }
                onClick={toggleInquiryVisible}
              >
                {iq.inquiry || 'Inquiry'}
              </Button>
              {/* <Button
              className="refresh-button"
              size="large"
              color="white"
              startIcon={<RefreshIcon />}
              onClick={() => window.location.reload()}
            >
              Refresh
            </Button> */}
              <Box style={{ width: '1px', alignSelf: 'stretch' }}>
                <Box style={{ width: '100%', height: '100%', background: '#fff' }} />
              </Box>
              <Box sx={{ display: 'flex', alignContent: 'center', gap: '6px', paddingLeft: '6px' }}>
                <CustomTooltip title="Refresh">
                  <div>
                    <RefreshIcon fontSize="large" onClick={() => window.location.reload()} />
                  </div>
                </CustomTooltip>
                {EnableRechargeRequest ? (
                  <CustomTooltip title={rh.recharge || 'Recharge'}>
                    <div>
                      <CurrencyRupeeIcon
                        fontSize="large"
                        onClick={() => {
                          setModal(mdt.cargoRechargeRequestModal)
                        }}
                      />
                    </div>
                  </CustomTooltip>
                ) : (
                  ''
                )}
                <CustomTooltip title="Profile">
                  <div ref={profileButtonRef} onClick={toggleProfileVisible}>
                    <AccountCircleIcon fontSize="large" />
                  </div>
                </CustomTooltip>
              </Box>
            </div>
            {/*            
            <Button
              size="large"
              color="white"
              ref={profileButtonRef}
              className="profile-button"
              startIcon={<AccountCircleIcon />}
              sx={{ background: profileVisible ? '#0072D9' : 'inherit' }}
              onClick={toggleProfileVisible}
              endIcon={
                profileVisible ? (
                  <FontAwesomeIcon icon={faCaretUp} className="updown" />
                ) : (
                  <FontAwesomeIcon icon={faCaretDown} className="updown" />
                )
              }
            >
              Profile
            </Button> */}
            <Portal container={document.getElementById('root')}>
              <Box
                className="model--wrapper"
                style={{ display: inquiryVisible ? 'block' : 'none', top: '52px' }}
                onClick={toggleInquiryVisible}
              >
                <Box className="profile-section" style={inquiryDropPortalStyle} ref={profilePopupRef}>
                  {roleRights?.Table1?.[0]?.AllowBranchDetSMS == 1 && (
                    <Button
                      sx={{ width: '100%', fontSize: '15px', padding: '8px', textTransform: 'none', color: 'gray' }}
                      id={`branchInquiry`}
                      className="inquiry-items"
                      onClick={() => {
                        updateModal(true, mdt.branchInquiryPopup)
                      }}
                      onKeyDown={(e) => lineInputNavigation3(e, `pricingInquiry`, `pricingInquiry`, `branchInquiry`)}
                    >
                      {iq.branchInquiry || 'Branch Inquiry'}
                    </Button>
                  )}
                  <Button
                    sx={{ width: '100%', fontSize: '15px', padding: '8px', textTransform: 'none', color: 'gray' }}
                    id={`pricingInquiry`}
                    className="inquiry-items"
                    style={{ borderBottom: 'none' }}
                    onKeyDown={(e) => lineInputNavigation3(e, `branchInquiry`, `branchInquiry`, `pricingInquiry`)}
                    onClick={() => {
                      updateModal(true, mdt.pricingInquiryPopup)
                    }}
                  >
                    {iq.pricingInquiry || 'Pricing Inquiry'}
                  </Button>
                </Box>
              </Box>
            </Portal>
            <Portal container={document.getElementById('root')}>
              <Box
                className="model--wrapper"
                style={{ display: profileVisible ? 'block' : 'none', top: '52px' }}
                onClick={toggleProfileVisible}
              >
                <Box className="profile-section" style={dropPortalStyle} ref={profilePopupRef}>
                  <Box className="profile-items">
                    <Typography varient="p" className="profile-items-label">
                      {cs.companyName || 'Company Name'}
                    </Typography>
                    <Typography varient="p" className="profile-items-value">
                      {loginData.strCompanyName}
                    </Typography>
                  </Box>
                  <Box className="profile-items">
                    <Typography varient="p" className="profile-items-label">
                      {pf.branchName || 'Branch Name'}
                    </Typography>
                    <Typography varient="p" className="profile-items-value">
                      {loginData.strBranchName}
                    </Typography>
                  </Box>
                  <Box className="profile-items">
                    <Typography varient="p" className="profile-items-label">
                      {pf.userName || 'User Name'}
                    </Typography>
                    <Typography varient="p" className="profile-items-value">
                      {loginData.strUserName}
                    </Typography>
                  </Box>
                  <Box className="profile-items flex-center-all">
                    <Box>
                      <Button
                        sx={{ width: '100%', fontSize: '14px' }}
                        onClick={(e) => {
                          e.preventDefault()
                          e.stopPropagation()
                          setEnableBookingHistory(!enableBookingHistory)
                        }}
                      >
                        {pf.enableBookingHistory || 'ENABLE BOOKING HISTORY'}
                        <FormControlLabel
                          sx={{
                            marginLeft: '1px',
                            '&.Mui-checked': {
                              color: '#004F9E !important',
                            },
                            '&.MuiFormControlLabel-root': {
                              marginRight: '0px !important',
                            },
                          }}
                          control={<Checkbox checked={enableBookingHistory} />}
                        />
                      </Button>
                    </Box>
                  </Box>
                  <Box className="profile-items">
                    <Box>
                      <Button
                        sx={{ width: '100%', fontSize: '14px' }}
                        onClick={() => updateModal(true, 'APIKEYUPDATEMODAL')}
                        disabled={loginData?.IsMTPLAdmin !== 1}
                      >
                        {pf.updateGoogleMapApiKey || 'Update Google Map API Key'}
                      </Button>
                    </Box>
                  </Box>
                  <Box className="profile-items">
                    <Box>
                      <Button sx={{ width: '100%', fontSize: '14px' }} onClick={() => updateModal(true, 'updatePassword')}>
                        {pf.updatePassword || 'Update Password'}
                      </Button>
                    </Box>
                  </Box>
                  <Box>
                    <Button startIcon={<LogoutIcon />} sx={{ width: '100%', fontSize: '16px' }} onClick={logout}>
                      {pf.logout || 'Logout'}
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Portal>
            <Portal container={document.getElementById('root')}>
              <Box
                className="model--wrapper"
                style={{
                  display: languageVisible ? 'block' : 'none',
                  top: '52px',
                }}
                onClick={() => setLanguageVisible(false)}
              >
                <Box
                  className="profile-section"
                  style={{
                    ...dropPortalStyle, right: window?.innerWidth - languageVisibleRef?.current?.getBoundingClientRect()?.right-20
                  }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {MultiligualDropData.map((item) => (
                    <Box
                      key={item.id}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        padding: '12px 16px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #e0e0e0',
                        background:item.code===language?'#0086ff':'#f5f5f5',
                        color:item.code===language?'#ffffff':'#000',
                        '&:hover': {
                         // backgroundColor: '#0086ff',
                        },
                      }}
                      onClick={() => {
                        setLanguage(item.code)
                        setLanguageVisible(false)
                      }}
                    >
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          minWidth: 40,
                          borderRadius: '4px',
                          backgroundColor: '#1976d2',
                          color: '#fff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '24px',
                          fontWeight: 600,
                        }}
                      >
                        {item.icon}
                      </Box>

                      <Typography
                        sx={{
                          fontSize: '18px',
                        }}
                      >
                        {item.name}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Portal>
            <Portal container={document.getElementById('root')}>
              <Box className="menu-section" style={{ left: menuVisible ? '0' : '-300px' }} ref={menuPopupRef}>
                <ul className="menu">
                  {mainMenu ? (
                    <>
                      <li onClick={(e) => handleMenu(booking, 0, e)}>HOME</li>
                      <li
                        onClick={(e) => handleMenu(dashBoard, 0, e)}
                        style={{
                          display: findObjctByValueFromArrayOfObject(reportsActive, 489, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                        }}
                      >
                        DASHBOARD
                      </li>
                      {(loginData?.intCompanyID===DEMO_COMPANY||DefaultCurrencyID===2) && 
                      <li onClick={(e) => handleMenu(DashBoardV2, 0, e)}
                      style={{
                          display: findObjctByValueFromArrayOfObject(reportsActive, 592, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                        }}
                      >DASHBOARD V2</li>}
                     
                      {loginData?.intCompanyID === STA_COMPANY_ID ? (
                        <li onClick={(e) => handleMenu(deliveryV2Cargo, 0, e)}>Delivery</li>
                      ) : (
                        ''
                      )}
                      <li
                        onClick={(e) => handleMenu(deliveryMemo, 0, e)}
                        style={{
                          display: findObjctByValueFromArrayOfObject(reportsActive, 554, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                        }}
                      >
                        {deliveryMemo}
                      </li>
                      <li
                        onClick={(e) => {
                          e.stopPropagation()
                          setMainMenu(false)
                          setMenuVisible(true)
                        }}
                      >
                        Reports <span className="forwardIosIcons">{<ArrowForwardIosIcon />}</span>
                      </li>
                      <li
                        onClick={(e) => {
                          e.stopPropagation()
                          setMainMenu(false)
                          setAcountingMenu(true)
                        }}
                      >
                        Acounting Reports <span className="acountingForwardIosIcons">{<ArrowForwardIosIcon />}</span>
                      </li>
                      {/* <li onClick={() => handleMenu(admin, 15)}>Admin Update / Modify / Show LR</li> */}
                      <li
                        onClick={(e) => {
                          e.stopPropagation()
                          setMainMenu(false)
                          setAdminMenu(true)
                        }}
                        style={{
                          display: findObjctByValueFromArrayOfObject(reportsActive, 548, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                        }}
                      >
                        Admin Privilege <span className="acountingForwardIosIcons">{<ArrowForwardIosIcon />}</span>
                      </li>
                      <li
                        onClick={(e) => handleMenu(recharge, 18, e)}
                        style={{
                          display: findObjctByValueFromArrayOfObject(reportsActive, 547, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                        }}
                      >
                        Accounts Privilege
                      </li>
                      {showExpenseMenu ? (
                        <li
                          onClick={(e) => handleMenu(operationsPrivilege, 19, e)}
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 567, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          {operationsPrivilege}
                        </li>
                      ) : (
                        <></>
                      )}
                      {/* <li>Security Master</li> */}
                      <li
                        onClick={(e) => handleMenu(generalSettings, e)}
                        style={{
                          display: findObjctByValueFromArrayOfObject(reportsActive, 555, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                        }}
                      >
                        General Settings
                      </li>
                      <li
                        onClick={(e) => handleMenu(BrchUsrMaster, 17, e)}
                        style={{
                          display: findObjctByValueFromArrayOfObject(reportsActive, 556, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                        }}
                      >
                        {bum.branchAndUserSettings || 'Branch & User Settings'}
                      </li>
                      <li
                        onClick={(e) => {
                          e.stopPropagation()
                          setMainMenu(false)
                          setOutDeliveryMenu(true)
                        }}
                        style={{ justifyContent: 'space-between', paddingRight: '15px', display: showOutDeliveryMenu ? 'flex' : 'none' }}
                      >
                        <span>Out For Delivery</span> <span>{<ArrowForwardIosIcon />}</span>
                      </li>

                      {loginData.intCompanyID === 1 && (
                        <li
                          onClick={handleMtplMasterClick}
                        >
                          {mtpl.mtplMasterTitle || 'MTPL Master'} <span className="mtplMasterForwardIosIcons">{<ArrowForwardIosIcon />}</span>
                        </li>
                      )}
                      <li
                        onClick={(e) => handleMenu('planDispatch', 0, e)}
                        style={{
                          display: findObjctByValueFromArrayOfObject(reportsActive, 594, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                        }}
                      >
                        Plan Dispatch
                      </li>

                      {/* <li>
                        Policies <span className="forwardIosIcons">{<ArrowForwardIosIcon />}</span>
                      </li> */}
                    </>
                  ) : acountingMenu ? (
                    <>
                      <li
                        style={{ borderBottom: '2px solid lightgray', color: '#0086ff' }}
                        onClick={(e) => {
                          e.stopPropagation()
                          setMainMenu(true)
                          setAcountingMenu(false)
                        }}
                      >
                        {' '}
                        <span id="backIcons">{<ArrowBackIcon />}</span> Main menu
                      </li>
                      <div className="list--container" ref={listContainerRef} style={{ height: `${height}px` }}>
                        <h3 className="space">Acounting Report</h3>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(acountingReports, 3, e)}
                          style={{
                            // display: 'block',
                            display: findObjctByValueFromArrayOfObject(reportsActive, 217, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          Branch Credit Limit Transaction
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(acountingReports, 4, e)}
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 216, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          Branch Credit Limit Summary
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(acountingReports, 8, e)}
                          style={{
                            // display: 'block',
                            display: findObjctByValueFromArrayOfObject(reportsActive, 262, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          Party Credit Limit Transaction
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(acountingReports, 9, e)}
                          style={{
                            // display: 'block',
                            display: findObjctByValueFromArrayOfObject(reportsActive, 262, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          Party Credit Limit Summary
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(acountingReports, 5, e)}
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 253, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          Credit Limit Usage Report
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(acountingReports, 2, e)}
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 321, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          GST Report
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(acountingReports, 20, e)}
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 321, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          GST ReportV1
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(acountingReports, 1, e)}
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 514, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          GST Return File
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(acountingReports, 6, e)}
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 204, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          Generate Hisab Report
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(acountingReports, 10, e)}
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 204, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          Franchisee Pending ToPay Report
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(acountingReports, 11, e)}
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 204, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          Franchisee Settlement Report
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(acountingReports, 13, e)}
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 568, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                        >
                          Branch Wise & Dispatch Memo Collection
                        </li>
                        {/* Only visible for kenya */}
                          {companySettings?.DefaultCurrencyID === 2 && (
                            <>
                              <li
                                className="space"
                                onClick={(e) => handleMenu(acountingReports, 12, e)}
                              // style={{
                              //   display: findObjctByValueFromArrayOfObject(reportsActive, 503, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                              // }}
                              >
                                Mpesa Transaction Report
                              </li>
                              <li
                                className="space"
                                onClick={(e) => handleMenu(acountingReports, 21, e)}
                                style={{
                                  display: findObjctByValueFromArrayOfObject(reportsActive, 588, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                                }}
                              >
                                Banking Report
                              </li>
                              <li
                                className="space"
                                onClick={(e) => handleMenu(acountingReports, 22, e)}
                                style={{
                                  display: findObjctByValueFromArrayOfObject(reportsActive, 589, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                                }}
                              >
                                Black Book Report
                              </li>
                            </>
                          )}
                        {RAJESH_TRANSPORT === intCompanyID ? (
                            <>
                              <li className="space" onClick={(e) => handleMenu(acountingReports, 14, e)}
                                style={{
                                  display: findObjctByValueFromArrayOfObject(reportsActive, 579, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                                }}
                              >
                                Branch Due Report
                              </li>
                              <li className="space" onClick={(e) => handleMenu(acountingReports, 15, e)}
                                style={{
                                  display: findObjctByValueFromArrayOfObject(reportsActive, 580, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                                }}
                              >
                                Branch Payable Report
                              </li>
                              <li className="space" onClick={(e) => handleMenu(acountingReports, 16, e)}
                                style={{
                                  display: findObjctByValueFromArrayOfObject(reportsActive, 581, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                                }}
                              >
                                Booking Summary Report
                              </li>
                              <li className="space" onClick={(e) => handleMenu(acountingReports, 17, e)}
                                style={{
                                  display: findObjctByValueFromArrayOfObject(reportsActive, 582, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                                }}
                              >
                                Profit & Loss Report
                              </li>
                              <li className="space" onClick={(e) => handleMenu(acountingReports, 18, e)}
                                style={{
                                  display: findObjctByValueFromArrayOfObject(reportsActive, 583, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                                }}
                              >
                                OGPL Report
                              </li>
                              <li className="space" onClick={(e) => handleMenu(acountingReports, 19, e)}
                                style={{
                                  display: findObjctByValueFromArrayOfObject(reportsActive, 584, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                                }}
                              >
                                OGCL Report
                              </li>
                            </>
                        ) : null}
                          <li
                            className="space"
                            onClick={(e) => handleMenu(acountingReports, 7, e)}
                            style={{
                              display: findObjctByValueFromArrayOfObject(reportsActive, 448, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                            }}
                          >
                            Bus & Cargo Memo
                          </li>
                      </div>
                    </>
                  ) : mtplMasterMenu ? (
                    <>
                      <li
                        style={{ borderBottom: '2px solid lightgray', color: '#0086ff' }}
                        onClick={(e) => {
                          e.stopPropagation()
                          setMainMenu(true)
                          setMtplMasterMenu(false)
                        }}
                      >
                        {' '}
                        <span id="backIcons">{<ArrowBackIcon />}</span> Main menu
                      </li>
                      <div className="list--container" ref={listContainerRef} style={{ height: `${height}px` }}>
                        <h3 className="space">{mtpl.mtplMasterTitle || 'MTPL Master'}</h3>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(mtplMaster, 1, e)}
                          style={{ display: loginData.intCompanyID === 1 ? 'block' : 'none' }}
                        >
                          {mtpl.companyLuggageSettings || 'Company Luggage Settings'}
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(mtplMaster, 2, e)}
                          style={{ display: loginData.intCompanyID === 1 ? 'block' : 'none' }}
                        >
                          {mtpl.selectCompany || 'Select Company'}
                        </li>
                        <li
                          className="space"
                          onClick={(e) => handleMenu(mtplMaster, 3, e)}
                          style={{ display: loginData.intCompanyID === 1 ? 'block' : 'none' }}
                        >
                          {mtpl.cargoSharing || 'Cargo Sharing'}
                        </li>
                      </div>
                    </>
                  ) : outDeliveryMenu ? (
                    <>
                      <li
                        style={{ borderBottom: '2px solid lightgray', color: '#0086ff' }}
                        onClick={(e) => {
                          e.stopPropagation()
                          setMainMenu(true)
                          setOutDeliveryMenu(false)
                        }}
                      >
                        <span id="backIcons">{<ArrowBackIcon />}</span> Main menu
                      </li>
                      <div className="list--container" ref={listContainerRef} style={{ height: `${height}px` }}>
                        <h3 className="space">{od.outForDelivery || 'Out For Delivery'}</h3>
                        <li
                          className="space"
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 512, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                          onClick={(e) => handleMenu(pendingOutDelivery, 17, e)}
                        >
                          {od.pendingOutDelivery || pendingOutDelivery}
                        </li>
                        <li
                          className="space"
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 572, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                          onClick={(e) => handleMenu(updateOutDelivery, 17, e)}
                        >
                          {od.updateOutDelivery || updateOutDelivery}
                        </li>
                        <li
                          className="space"
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 513, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                          onClick={(e) => handleMenu(outDeliveryStatus, 17, e)}
                        >
                          {od.outDeliveryStatus || outDeliveryStatus}
                        </li>
                      </div>
                    </>
                  ) : adminMenu ? (
                    <>
                      <li
                        style={{ borderBottom: '2px solid lightgray', color: '#0086ff' }}
                        onClick={(e) => {
                          e.stopPropagation()
                          setMainMenu(true)
                          setAdminMenu(false)
                        }}
                      >
                        <span id="backIcons">{<ArrowBackIcon />}</span> Main menu
                      </li>
                      <div className="list--container" ref={listContainerRef} style={{ height: `${height}px` }}>
                        <h3 className="space">Admin Privilege</h3>
                        <li
                          className="space"
                          style={{
                            display: findObjctByValueFromArrayOfObject(reportsActive, 548, 'JobID', 'IsActive') === 1 ? 'block' : 'none',
                          }}
                          onClick={(e) => handleMenu(admin, 15, e)}
                        >
                          Admin update
                        </li>
                        <li
                          className="space"
                          style={{
                            display: AllowBranchselection === 1 ? 'block' : 'none',
                          }}
                          onClick={(e) => handleMenu(selectUser, 15, e)}
                        >
                          Select User
                        </li>
                      </div>
                    </>
                  ) : (
                    <>
                      <li style={{ borderBottom: '2px solid lightgray', color: '#0086ff' }} onClick={() => setMainMenu(true)}>
                        {' '}
                        <span id="backIcons">{<ArrowBackIcon />}</span> Main menu
                      </li>
                      <div className="list--container" ref={listContainerRef} style={{ height: `${height}px` }}>
                        <h3 className="space">Reports</h3>
                        {allReports(intCompanyID).map((item, i) => {
                          const reportItem = { ...item }
                          if (DefaultCurrencyID === 2 && reportItem.JobID === 193) {
                            reportItem.name = 'Parcel Journey Report'
                          }
                          return (
                            <li
                              key={i}
                              className="space"
                              onClick={(e) => handleMenu(reports, reportItem.reportNo, e)}
                              style={{
                                display:
                                  findObjctByValueFromArrayOfObject(reportsActive, reportItem.JobID, 'JobID', 'IsActive') === 1
                                    ? 'block'
                                    : 'none',
                              }}
                            >
                              {reportItem.name}
                            </li>
                          )
                        })}
                      </div>
                    </>
                  )}
                </ul>
              </Box>
            </Portal>
          </Toolbar>
        </AppBar>
      </Box>
      {showModal && mdt.searchPopup === modalType && <SearchLrPopupUI controlData={controlData} />}
      {mdt.cargoRechargeRequestModal === modal && showRechargeRequestModal()}
      {showModal && mdt.pricingInquiryPopup === modalType && <PricingInquiry updateModal={updateModal} />}
      {showModal && mdt.branchInquiryPopup === modalType && <BranchInquiry updateModal={updateModal} />}
      {showModal && mdt.lrTrackingPopup === modalType && (
        isHorizontalLrTracing(companySettings) ? (
          <LrTrackingHorizontalPopupUI controlData={controlData} />
        ) : (
          <LrTrackingPopupUI controlData={controlData} />
        )
      )}
      {showModal && modalType === 'camcelBookingSuccess' && <CancelBookingSuccessModal />}
      {showModal && modalType === 'camcelDeliverySuccess' && <CancelDeliverySuccessModal />}
      {modal === 'bookingTicketReprint' && <ShowTicketPreview />}
      {modal === 'reprintSticker' ? <ShowStickerPreview /> : ''}
      {showModal && modalType === 'APIKEYUPDATEMODAL' ? <APIKeyUpdateModal updateModal={updateModal} updateAlert={setAlert} /> : ''}
      {showModal && modalType === 'updatePassword' ? <UpdatePassword updateModal={updateModal} updateAlert={setAlert} /> : ''}

      {localPopup === 'bookingCancelUI' && <ShowBookingCancel />}
      {localPopup === 'deliveryCancelUI' && <ShowDeliveryCancel />}
      {localPopup === 'bookingReprintUI' && <ShowBookingReprint />}
      {localPopup === 'deliveryReprintUI' && <ShowDeliveryReprint />}
      {showModal && modalType === 'BookingCancelByAdmin' ? (
        <BookingCancelByAdminUICopy
          handleConfirmPop={handleConfirmPop}
          handleCancelBooking={handleCancelBooking}
          loginData={loginData}
          updateModal={updateModal}
          lrInfo={selectLr}
          lrBookingInfo={firstStatus}
          userList={ownChildUsers}
          consignmentDetails={consignmentDetails}
          IsLoggedInUserForOfflineBooking={IsLoggedInUserForOfflineBooking}
        />
      ) : (
        ''
      )}
      {modal === 'reprintStickerConfirmation' && (
        <StickerConfirmation
          yesAction={handleStickerPrint}
          yesDefault={SetDefaultYesOnPrint}
          noAction={() => window.location.reload(false)}
          stickerRange={stickerRange}
        />
      )}
      {confirmPop.isOpen && ShowDispatchSuccess()}
      {alert.show && (
        <Alert
          msg={alert.msg}
          error={!alert?.success}
          success={alert?.success || false}
          close={() => (alert.close ? alert.close() : handleAlert(false, alert.nextId))}
        />
      )}
      {modal === 'shortcutsPopup' && <ShortcutsPopup dropPortalStyle={dropPortalStyle} shortcutsPopupRef={shortcutsPopupRef} />}
      {odpPopupOpen && (
        <MtplOdpValidationModal loginData={loginData} onValidated={handleOdpValidated} onClose={handleOdpClose} />
      )}
    </>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {
  getDestBranchCreditLimit,
  updateModal,
  updatePaymentType,
  updateSearchBy,
  setSearchLrData,
  updateSelectedActivity,
  cancelBooking,
  cencelDelivery,
  rePrintCargoBooking,
  luggegePrint,
  ticketFormatAll,
  userRollRightEditRights,
  getOwnChildUsers,
  updateAlertError,
  cancelBookingByAdmin,
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
